<template>
  <v-container class="home">
    <h3>Janus Library Ready: {{ janusLibraryReady }}</h3>
    <v-row>
      <v-col>
        <v-text-field label="Display Name"
                      v-model="displayName"></v-text-field>
      </v-col>
      <v-col>
        <v-btn @click="connectServer"
               v-if="!serverConnected">CONNECT
        </v-btn>
        <v-btn @click="disconnect"
               v-if="serverConnected">DISCONNECT
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-row>
          <v-col>
            <h3>Server connected: {{ serverConnected }}</h3>
            <h3>Plugin Attached: {{ pluginAttached }}</h3>
            <h3>Room ID: {{ roomId }}</h3>
            <h3>Participant ID: {{ participantId }}</h3>
          </v-col>
        </v-row>
        <v-row v-if="myStream">
          <v-col>
            <v-select :items="bitrateItems"
                      v-model="currentBitrate"
                      @change="changeBitRate"></v-select>
          </v-col>
        </v-row>
        <v-row v-if="myStream">
          <v-col>
            <v-btn @click="toggleMute">{{ isMuted ? 'UNMUTE' : 'MUTE' }}</v-btn>
          </v-col>
        </v-row>

      </v-col>
      <v-col>
        <video width="100%" height="400px" id="myVideo" autoplay playsinline muted="muted"></video>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(publisher, id) in publisherHandles">
        <v-row>
          <v-col>
            <video width="100%" height="200px" :srcObject.prop="publisherStream(id).stream" autoplay playsinline v-if="publisherStream(id)"></video>
          </v-col>
        </v-row>
        <v-row>
          <v-col>{{ publisher.rfdisplay }}</v-col>
          <v-col>{{ publisher.rfid }}</v-col>
          <v-col>{{ publisher.getBitrate() }}</v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, reactive, ref} from '@vue/composition-api'
import Janus from '@/assets/janus'
import $ from 'jquery'

export default {
  name: 'Home',
  setup(props, {root}) {
    const janusLibraryReady = ref(false);
    const displayName = ref(null);

    const janus = ref(null);
    const pluginHandle = ref(null);
    const roomId = ref(null);
    const participantId = ref(null);
    const privateId = ref(null);

    const initJanus = function () {
      Janus.init({
        debug: 'all',
        callback() {
          janusLibraryReady.value = true;
        },
      })
    };
    const onJanusError = function (error) {
      // Janus.error(error);
      alert(error, function () {
        window.location.reload();
      });
    };
    const serverConnected = ref(false);
    const connectServer = function () {
      janus.value = new Janus({
        server: 'wss://teamnotejanus.southeastasia.cloudapp.azure.com:8989/janus',
        success() {
          serverConnected.value = true;
          attachPlugin();
        },
        error: onJanusError,
        destroyed() {
          window.location.reload();
        },
      })
    };
    const disconnect = function () {
      janus.value.destroy();
    };

    const pluginAttached = ref(false);
    const attachPlugin = function () {
      janus.value.attach({
        plugin: "janus.plugin.videoroom",
        success(pHandle) {
          pluginAttached.value = true;
          pluginHandle.value = pHandle;
          onPluginAttached();
        },
        error(error) {
          Janus.error("  -- Error attaching plugin...", error);
          alert("Error attaching plugin... " + error);
        },
        consentDialog(on) {
          Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
        },
        iceState(state) {
          Janus.log("ICE state changed to " + state);
        },
        mediaState(medium, on) {
          Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
        },
        webrtcState: function (on) {
          Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
        },
        onmessage: onPluginMessage,
        onlocalstream: onLocalStream,
        oncleanup() {
          Janus.log(" ::: Got a cleanup notification: we are unpublished now :::");
          myStream.value = null;
        },
      })
    };
    const onPluginAttached = function () {
      joinRoom();
    };
    const onPluginMessage = function (message, jsep) {
      console.log(" ::: Got a message (Plugin) :::", message, jsep);
      let event = message['videoroom'];
      if (event === 'joined') {
        onJoinRoom(message);
        if (message['publishers']) {
          onReceivePublisher(message['publishers'])
        }
      } else if (event === 'destroyed') {
        onRoomDestroyed(message);
      } else if (event === "event") {
        if (message['publishers']) {
          onReceivePublisher(message['publishers'])
        }
      }
      if (jsep) {
        console.log("Handling SDP as well...", jsep);
        pluginHandle.value.handleRemoteJsep({jsep: jsep});
      }
    };

    const joinRoom = function () {
      pluginHandle.value.send({
        message: {
          request: 'join',
          ptype: 'publisher',
          room: 369,
          display: displayName.value || 'NO NAME',
        }
      });
    };
    const onJoinRoom = function (message) {
      roomId.value = message['room'];
      participantId.value = message['id'];
      privateId.value = message['private_id'];

      publishOwnFeed(true);
    };
    const onRoomDestroyed = function (message) {
      confirm("The room has been destroyed");
      window.location.reload();
    };

    const myStream = ref(null);
    const isMuted = ref(true);
    const toggleMute = function () {
      var muted = pluginHandle.value.isAudioMuted();
      Janus.log((muted ? "Unmuting" : "Muting") + " local stream...");
      if (muted)
        pluginHandle.value.unmuteAudio();
      else
        pluginHandle.value.muteAudio();
      isMuted.value = pluginHandle.value.isAudioMuted();
    };
    const currentBitrate = ref(256000);
    const bitrateItems = ref([
      // {text: 'No Limit', value: 0},
      {text: 'Cap to 128kb', value: 128000},
      {text: 'Cap to 256kb', value: 256000},
      {text: 'Cap to 512kb', value: 512000},
      {text: 'Cap to 1024kb', value: 1024000},
      // {text: 'Cap to 1.5mb', value: 1500000},
      // {text: 'Cap to 2mb', value: 2000000},
    ])
    const publishOwnFeed = function (useAudio) {
      pluginHandle.value.createOffer(
          {
            // Add data:true here if you want to publish datachannels as well
            media: {audioRecv: false, videoRecv: false, audioSend: useAudio, videoSend: true},	// Publishers are sendonly
            // media: {video: 'screen', audioSend: true, videoRecv: false},
            // If you want to test simulcasting (Chrome and Firefox only), then
            // pass a ?simulcast=true when opening this demo page: it will turn
            // the following 'simulcast' property to pass to janus.js to true
            success: function (jsep) {
              console.log(jsep);
              Janus.debug("Got publisher SDP!", jsep);
              var publish = {request: "configure", audio: true, video: true, bitrate: currentBitrate.value};
              // You can force a specific codec to use when publishing by using the
              // audiocodec and videocodec properties, for instance:
              // 		publish["audiocodec"] = "opus"
              // to force Opus as the audio codec to use, or:
              // 		publish["videocodec"] = "vp9"
              // to force VP9 as the videocodec to use. In both case, though, forcing
              // a codec will only work if: (1) the codec is actually in the SDP (and
              // so the browser supports it), and (2) the codec is in the list of
              // allowed codecs in a room. With respect to the point (2) above,
              // refer to the text in janus.plugin.videoroom.jcfg for more details
              pluginHandle.value.send({message: publish, jsep: jsep});
            },
            error: function (error) {
              Janus.error("WebRTC error:", error);
              if (useAudio) {
                publishOwnFeed(false);
              } else {
                alert("WebRTC error... " + error.message);
              }
            }
          });
    };
    const onLocalStream = function (stream) {
      Janus.debug(" ::: Got a local stream :::", stream);
      myStream.value = stream;
      pluginHandle.value.muteAudio();
      Janus.attachMediaStream($('#myVideo').get(0), myStream.value);
    };
    const changeBitRate = function () {
      pluginHandle.value.send({message: {request: "configure", bitrate: currentBitrate.value}});
    };
    const unpublishOwnFeed = function () {
      pluginHandle.value.send({
        message: {request: 'unpublish'}
      })
    };

    const publisherHandles = reactive({});
    const publisherStreams = reactive({});
    const publisherStream = function (id) {
      return publisherStreams[id];
    };
    const onReceivePublisher = function (publishers) {
      console.log("Got a list of available publishers/feeds:", publishers);
      publishers.forEach((p) => {
        addRemoteFeed(p['id'], p['display'], p['audio_codec'], p['video_codec']);
      })
    };
    const onPublisherLeave = function () {
    };
    const addRemoteFeed = function (id, display, audio, video) {
      janus.value.attach({
        plugin: 'janus.plugin.videoroom',
        success(publisherHandle) {
          // publisherHandles[id] = publisherHandle;
          publisherHandle.simulcastStarted = false;
          // We wait for the plugin to send us an offer
          var subscribe = {
            request: "join",
            room: roomId.value,
            ptype: "subscriber",
            feed: id,
            private_id: participantId.value
          };
          // In case you don't want to receive audio, video or data, even if the
          // publisher is sending them, set the 'offer_audio', 'offer_video' or
          // 'offer_data' properties to false (they're true by default), e.g.:
          // 		subscribe["offer_video"] = false;
          // For example, if the publisher is VP8 and this is Safari, let's avoid video
          if (Janus.webRTCAdapter.browserDetails.browser === "safari" &&
              (video === "vp9" || (video === "vp8" && !Janus.safariVp8))) {
            if (video) {
              video = video.toUpperCase();
            }
            console.log("Publisher is using " + video + ", but Safari doesn't support it: disabling video");
            subscribe["offer_video"] = false;
          }
          publisherHandle.videoCodec = video;
          root.$set(publisherHandles, id, publisherHandle);
          // Vue.set(publisherHandles, id, publisherHandle);
          publisherHandle.send({message: subscribe})
        },
        error(error) {
          console.log("  -- Error attaching plugin (Subscriber)...", error);
        },
        onmessage(message, jsep) {
          console.log(" ::: Got a message (Subscriber) :::", message);
          let publisherHandle = publisherHandles[id];
          let event = message['videoroom'];
          if (event) {
            if (event === "attached") {
              publisherHandle.rfid = message['id'];
              publisherHandle.rfdisplay = message['display'];
            }
          }

          if (jsep) {
            Janus.debug("Handling SDP as well...", jsep);
            // Answer and attach
            publisherHandles[id].createAnswer(
                {
                  jsep: jsep,
                  // Add data:true here if you want to subscribe to datachannels as well
                  // (obviously only works if the publisher offered them in the first place)
                  media: {audioSend: false, videoSend: false},	// We want recvonly audio/video
                  success: function (jsep) {
                    Janus.debug("Got SDP!", jsep);
                    var body = {request: "start", room: roomId.value};
                    publisherHandles[id].send({message: body, jsep: jsep});
                  },
                  error: function (error) {
                    Janus.error("WebRTC error:", error);
                    console.log("WebRTC error... " + error.message);
                  }
                });
          }
        },
        onremotestream: function (stream) {
          let publisherHandle = publisherHandles[id];
          let publisherStream = {};
          console.log(publisherHandle);
          console.log("Remote feed #" + id + ", stream:", stream);
          // console.log(URL.createObjectURL(stream));
          publisherStream.stream = stream;
          var videoTracks = stream.getVideoTracks();
          // No remote video
          publisherStream.no_video = !videoTracks || videoTracks.length === 0;

          if (Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "firefox" ||
              Janus.webRTCAdapter.browserDetails.browser === "safari") {
            publisherStream.bitrate = publisherHandle.getBitrate();
          } else {
            publisherStream.bitrate = 0;
          }
          root.$set(publisherStreams, id, publisherStream);
        },
        oncleanup() {
          console.log(" ::: Got a cleanup notification (remote feed " + id + ") :::");
          // let newPublisherHandles = publisherHandles;
          // delete newPublisherHandles[id];
          root.$delete(publisherHandles, id);
          root.$delete(publisherStreams, id);
        },
      })
    }

    onMounted(() => {
      initJanus();
    })

    return {
      janusLibraryReady,
      displayName,
      roomId,
      participantId,
      connectServer,
      disconnect,
      serverConnected,
      pluginAttached,

      myStream,
      isMuted,
      toggleMute,
      currentBitrate,
      bitrateItems,
      changeBitRate,

      publisherHandles,
      publisherStream,
    }
  },
}
</script>
